import CHARACTER_MALE from "./character-male.jpg";
import CHARACTER_FEMALE from "./character-female.jpg";
import JOB_ONLINE_SELLING from "./job-online-selling.png";
import JOB_SERVICE from "./job-service.png";
import PERSON_TYPE_PERSONAL from "./person_type-personal.png";
import PERSON_TYPE_CORP from "./person_type-corp.png";
import INCOME_RATE_TRUE from "./income_rate-true.png";
import INCOME_RATE_FALSE from "./income_rate-false.png";
import VAT_TRUE from "./vat-true.png";
import VAT_FALSE from "./vat-false.png";
import VAT_NEEDED_TRUE from "./vat_needed-true.png";
import VAT_NEEDED_FALSE from "./vat_needed-false.png";
import GOODS_TYPE_TRUE from "./goods_type-true.png";
import GOODS_TYPE_FALSE from "./goods_type-false.png";
import CHEAT_TRUE from "./cheat-true.png";
import CHEAT_FALSE from "./cheat-false.png";
import FINAL_DECISION_PERSONAL from "./final_decision-personal.png";
import FINAL_DECISION_CORP from "./final_decision-corp.png";

export default {
  CHARACTER_MALE,
  CHARACTER_FEMALE,
  JOB_ONLINE_SELLING,
  JOB_SERVICE,
  PERSON_TYPE_PERSONAL,
  PERSON_TYPE_CORP,
  INCOME_RATE_TRUE,
  INCOME_RATE_FALSE,
  VAT_TRUE,
  VAT_FALSE,
  VAT_NEEDED_TRUE,
  VAT_NEEDED_FALSE,
  GOODS_TYPE_TRUE,
  GOODS_TYPE_FALSE,
  CHEAT_TRUE,
  CHEAT_FALSE,
  FINAL_DECISION_PERSONAL,
  FINAL_DECISION_CORP,
};
